var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"open-alert text-center rounded",attrs:{"color":_vm.alertColor,"max-width":_vm.maxWidth,"outlined":_vm.outlined,"dense":""}},[_c(_vm.small ? 'small' : 'div',{tag:"component"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }